export const checkSelectorExists = (selector, options = {}) => {
  const { timeout, signal } = options;

  return new Promise((resolve, reject) => {
    const el = document.querySelector(selector);
    if (el) {
      resolve(el);
      return;
    }

    let timeoutId;

    const observer = new MutationObserver(() => {
      const el = document.querySelector(selector);
      if (el) {
        cleanup();
        resolve(el);
      }
    });

    const cleanup = () => {
      observer.disconnect();
      clearTimeout(timeoutId);
    };

    observer.observe(document.body, { childList: true, subtree: true });

    if (timeout) {
      timeoutId = setTimeout(() => {
        cleanup();
        reject(new Error("Selector not found"));
      }, timeout);
    }

    if (signal) {
      signal.addEventListener("abort", () => {
        cleanup();
        reject(new Error("Aborted"));
      });
    }
  });
};
